<template>
    <FormWrapper :is-loading="isLoading">
        <PageTitle title="Staff Documents" slot="title" link="/helpContent/Menu List" />
        <ValidationObserver ref="validator" >
            <FormRow>
                <div class="col-sm-2">
                    <FormSelect label="User Type" :items="userTypeList" item-name="name" item-value="id" v-model="filtering.selectedUserTypeId" :onChange="getStaffList" rules="required"/>
                </div>
                <div class="col-sm-2">
                    <FormSelect label="Select Staff" :items="staffList" item-name="Name" item-value="id" v-model="filtering.selectedStaffId" rules="required"/>
                </div>
                <div class="col-sm-2">
                    <FormSelect label="Document Category" :items="documentCategoryList" item-name="DocumentCategory" item-value="id" v-model="filtering.selectedDocumentCategoryId" />
                </div>
                <div class="col-sm-3">
                    <FormButton style="margin-top: 5px" type="primary" @click="search" :rounded="true">
                        <Icon type="ios-search" />
                    </FormButton>
                </div>
            </FormRow>
        </ValidationObserver>
        <DataTable :actions="true"
            :data="documentList"
            :columns="tableConfig"
            :is-loading="isLoading"
            @on-page-change="pageChange"
            @on-selection-change="selectChange"
            :pagination="pagination"
            @on-sort-change="sortChange">
            <template slot="actionsLeft">
                <TableButton @click="() => add()">
                    <img :src="require(`Assets/images/plus-1.png`)"/>
                  Add
                </TableButton>
                <TableButton @click="() => remove()">
                    <img :src="require(`Assets/images/del.png`)"/>
                    Delete
                </TableButton>
            </template>
        </DataTable>
        <Popup title="Information" :value="warningModal.visible" @close="() => showWarningModal(false)">
            {{ warningModal.message }}
            <div slot="footer">
                <FormButton v-if="warningModal.buttons.cancel" @click="() => showWarningModal(false)">Cancel</FormButton>
                <FormButton v-if="warningModal.buttons.confirm" type="success" @click="confirmDelete">Confirm</FormButton>
                <FormButton v-if="warningModal.buttons.ok" @click="() => showWarningModal(false)">Ok</FormButton>
            </div>
        </Popup>
        <Popup title="Success" type="success" :value="showMessage.isVisible" @close="() => (showMessage.isVisible = false)" :closable="true">
            {{ showMessage.message }}
        </Popup>
    </FormWrapper>
</template> 

<script>
    import FormWrapper from 'Components/form/FormWrapper';
    import PageTitle from 'Components/layout/PageTitle';
    import DataTable from 'Components/DataTable';
    import loadingMixin from 'Mixins/loadingMixin';
    import {getAllStaff, getAllActiveDeactiveStaff, documentCategory, getStaffDocumentList, deleteDocument} from '../api';
    import tableConfig from './table';
    import validateSelectedRows from "Mixins/validateSelectedRows";
    import { ValidationObserver } from 'vee-validate';
    export default {
        name: "List",
        mixins: [loadingMixin, validateSelectedRows], 
        components: {
            FormWrapper,
            DataTable,
            PageTitle,
            ValidationObserver
        },
        data() {
            return {
                filtering: {
                    selectedUserTypeId: null,
                    selectedStaffId: null,
                    selectedDocumentCategoryId: null
                },
                sorting: {
                    key: 'Name',
                    order: 'asc'
                },
                pagination: {
                    perPage: 10,
                    page: 1,
                    total: 0
                },
                tableConfig,
                userTypeList:[
                    {
                        'id': 'All',
                        'name': 'All Users'
                    },
                    {
                        'id': 'Active',
                        'name': 'Active Users'
                    },
                    {
                        'id': 'Deactive',
                        'name': 'Deactive Users'
                    }
                ],
                staffList: [],
                documentCategoryList: [],
                selectedRows: [],
                documentList: [],
                allStaffList: [],
                activeStaffList: [],
                showMessage: {
                    isVisible: false,
                    message: "",
                }
            }
        },
        computed: {
          userData() {
              return this.$store.state.user.user
            }
        },
        watch: {
        },
        created() {
            this.getAllList();
        },
        methods: {
            add(){
                this.$router.push({ path: `/addHRDocuments` });
            },
            remove(){
                if (this.validateSelectedLength(1)) {
                    if (this.deleteSelectedValue()) {
                    }
                }
            },
            selectChange(data) {
                this.selectedRows = data;
            },
            search(){
                this.pagination.page = 1;
                this.getDataByFilter();
            },
            sortChange(data) {
                this.sorting.key = data.key;
                this.sorting.order = data.order;
                this.getDataByFilter()
            },
            confirmDelete() {
                this.showWarningModal(false);
                const data = {
                    documentId: this.selectedRows[0].id,
                };

                deleteDocument(data).then((res) => {
                    if (res.data[0].status > 1) {
                        this.showWarningModal(true);
                        this.selectedRows=[];
                        this.warningModal.buttons.ok =true;
                        this.warningModal.buttons.cancel =false;
                        this.warningModal.buttons.confirm =false;
                        this.warningModal.message = res.data[0].message;
                    } else {
                        this.selectedRows=[];
                        this.warningModal.buttons.ok =true;
                        this.warningModal.buttons.cancel =false;
                        this.warningModal.buttons.confirm =false;
                        this.showMessage.isVisible = true;
                        this.showMessage.message = res.data[0].message;
                        this.getDataByFilter();
                    }
                });
            },
            getDataByFilter() {
                setTimeout(() => {
                    this.$refs.validator.validate().then((result) => {
                        if (result) {
                            this.showLoader();
                            const { key, order } = this.sorting;
                            const { perPage, page } = this.pagination;
                            const filters = {};
                            if (this.filtering.selectedStaffId) {
                                filters.staffId = this.filtering.selectedStaffId;
                            }
                            if (this.filtering.selectedDocumentCategoryId) {
                                filters.documentCategoryId = this.filtering.selectedDocumentCategoryId;
                            }
                            const data = {
                                filterjson: {
                                    filter: [filters],
                                    sort: [{ key, order }],
                                    paging: [
                                        {
                                            startIndex: page,
                                            pageSize: perPage
                                        }
                                    ]
                                }
                            };
                            getStaffDocumentList(data)
                                .then(this.handleResponse)
                                .catch(this.handleError)
                        }
                    })
                },
                50
                )
            },
            pageChange(page) {
                this.pagination.page = page;
                this.getDataByFilter()
            },
            handleResponse(response) {
                this.hideLoader();
                this.documentList = response.data;
                this.pagination.total = response.NumberOfRecords;
            },
            async getAllList() {
                //Changes by Mahima on 18th July 2023: Fixed JIRA bug, NEIN-54
                this.filtering.selectedUserTypeId= "Active";
                this.getStaffList();
                documentCategory().then((res) => {
                    this.documentCategoryList = res.data;
                });
            },
            async getStaffList(ele) {
                if (ele != undefined) {
                    this.filtering.selectedUserTypeId=ele;
                }
                if(this.filtering.selectedUserTypeId){
                    if (this.filtering.selectedUserTypeId === "All") {
                        getAllActiveDeactiveStaff().then((res)=>{
                            this.staffList=res.data
                        });
                    } else if (this.filtering.selectedUserTypeId === "Active") {
                        getAllStaff().then((res)=>{
                            this.staffList=res.data
                        });
                    } else if (this.filtering.selectedUserTypeId === "Deactive") {
                        await getAllActiveDeactiveStaff().then((res)=>{
                            this.allStaffList=res.data;
                        });
                        
                        await getAllStaff().then((res)=>{
                            this.activeStaffList = res.data;
                        });

                        let activeselectedStaffIds = [];
                        for (let j = 0; j < this.activeStaffList.length; j++) {
                            activeselectedStaffIds.push(this.activeStaffList[j].id);
                        }

                        this.staffList = [];
                        this.allStaffList.forEach((item) => {
                            if (activeselectedStaffIds.indexOf(item.id) == -1) {
                                this.staffList.push(item);
                            }
                        });
                    }
                }
            },
        }
    }
</script>

<style lang="scss" module>
    .pagination {
        margin: 10px 0 0;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        line-height: 26px;
    }

    .paginationText {
        margin: 0 20px;
    }

    .paginationButton {
        cursor: pointer;
        width: 26px;
        text-align: center;
        transition: background-color .2s ease-in-out,color .2s ease-in-out, box-shadow 200ms ease
    }

    .paginationButton:hover {
        background: #57a3f3;
        color: #fff;
        &:hover {
            box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
        }
    }

    .filter {
        margin: -10px 0 10px;
    }

    .filterItem {
        display: inline-block;
        margin: 0 15px 15px 0;
    }

    .filterItemCheckbox {
        flex-basis: auto;
        align-self: flex-start;
        margin-top: 13px;
    }
</style>
